export const formatDateForInput = (date: string) => {
  if (!date) return "";
  const d = new Date(date);
  return d.toISOString().split("T")[0]; // Converts to YYYY-MM-DD
};
